module.exports = __webpack_public_path__ + "img/seedpaper-exuberant-orange.ab968378.png";